import { render, staticRenderFns } from "./MSExchangeSettings.vue?vue&type=template&id=08af4b06&scoped=true&lang=pug"
import script from "./MSExchangeSettings.vue?vue&type=script&lang=js"
export * from "./MSExchangeSettings.vue?vue&type=script&lang=js"
import style0 from "./MSExchangeSettings.vue?vue&type=style&index=0&id=08af4b06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af4b06",
  null
  
)

export default component.exports